export default "__VITE_ASSET__Da2pEeG8__"